module.exports = __webpack_public_path__ + "static/media/people-group.117ee22a.svg";